import axios from "axios";
import { API_URL } from "../../constants";

import _ from "lodash";
export default {
    getAllEnquiry: (page, pageSize, searchData) => {
        const filteredParams = _.pickBy(
            searchData,
            (value) => !_.isNil(value) && value !== false && value !== ""
          );
        return axios.get(API_URL.ENQUIRY_GET, {
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
            params: {
                page: page,
                pageSize: pageSize,
                search: filteredParams.search,
                enquiry_status: filteredParams.status,
                from: filteredParams.from,
                to: filteredParams.to,
            },
        });
    },
    updateStatusEnquiry: (id, data) => {

        return axios.patch(`${API_URL.ENQUIRY_GET}/${id}`, data, {
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
        });
    },


    getAllEnquiryfilter: (page, pageSize, searchParams) => {
        const filteredParams = _.pickBy(
            searchParams,
            (value) => !_.isNil(value) && value !== false && value !== ""
        );
        return axios.get(`${API_URL.CLIENTS}`, {
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
            params: {
                page: page,
                pageSize: pageSize,
                ...filteredParams,
            },
        });
    },
};


